import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import HostContainer from "./clients/HostContainer";
import LoadingSpinner from "./shared/components/LoadingSpinner";
import PlayerContainer from "./clients/PlayerContainer";
import Login from "./clients/playerComponents/Login";
import { MantineProvider } from "@mantine/core";
import { AuthProvider } from "./shared/contexts/AuthContext";
import { CastSenderProvider } from "./shared/contexts/CastSenderContext";
import Profile from "./Profile/Profile";

function App() {
  return (
    <Router>
      <main>
        <Suspense
          fallback={
            <div className="center">
              <LoadingSpinner asOverlay />
            </div>
          }
        >
          <MantineProvider
            withGlobalClasses
            withCssVariables
            theme={{
              breakpoints: {
                xs: "30em",
                sm: "48em",
                md: "64em",
                lg: "74em",
                xl: "90em",
              },
            }}
          >
            <AuthProvider>
              <CastSenderProvider>
                <Routes>
                  <Route path="/brig" element={<Profile />} />
                  <Route path="/" element={<PlayerContainer />} />
                  <Route path="/host" element={<HostContainer />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </CastSenderProvider>
            </AuthProvider>
          </MantineProvider>
        </Suspense>
      </main>
    </Router>
  );
}

export default App;
